;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Instance = APP.module('instance');

	/**
	 * section = 'leaderboard' | 'other' | 'promo'
	 */
	APP.MREC_EXTENDS = {
		initMREC: function(sections, initCallback) {
			if(_.isEmpty(sections)) {
				throw new Error('No sections were added');
			}
			this.is_mobile = window.isMobile();
			const callback = initCallback || 'setMREC';

			if(!this.model) {
				this.model = new Backbone.Model();
			}

			const mrecs = Instance.mrecs && Instance.mrecs.toJSON();

			if(_.isEmpty(mrecs)) {
				const method = this[callback].bind(this, sections);
				this.listenTo(APP.vent, 'mrecs:fetched', method);
				// Instance.mrecs.set({
				// 	listening: true
				// })
			} else {
				this[callback](sections);
			}

			return this;
		},

		setMREC: function (sections) {

			const mrecs = this.getMRECs();

			let mrecs_model = {};
			_.each(sections, (section) => {
				const mrec_section = _.find(mrecs, { section });

				if(mrecs && mrec_section) {
					mrecs_model[section] = mrec_section
				}
			});

			if(!_.isEmpty(mrecs_model)) {
				this.model.set({
					mrecs: mrecs_model
				})
			}

			this.render();
		},

		setMRECs(sections) {
			const mrecs = this.getMRECs();
			const filtered = _.filter(mrecs, function(mrec) {
				return sections.includes(mrec.section);
			});
			if (!_.isEmpty(filtered))  {
				this.model.set({
					mrecs: _.indexBy(filtered, 'platform'),
				});
			}

			this.render();

		},

		getMRECs() {
			const mrecs = Instance.mrecs && Instance.mrecs.toJSON();
			return _.filter(mrecs, mrec => mrec.game === CONFIG.GAME || !mrec.game)
		}
	}

}(window, APP, Backbone, Marionette, $, _));